module.exports = __webpack_public_path__ + "static/media/PDF_118.e52fc360.pdf";